import { handleResponse, handleError } from "./apiUtils";
import Config from "../Config";

let loginid = localStorage.getItem("loginUserID");
let Auth0token = localStorage.getItem("Auth0token");
let UserCompanyId = localStorage.getItem("UserCompanyId");

export async function getArticleTimeWiseScanningAnalyticReport(
  startdate,
  enddate,
  articleId,
  articlevariantId,
  pagecount
) {
  if (Auth0token === null || Auth0token === "" || Auth0token === undefined) {
    Auth0token = await localStorage.getItem("Auth0token");
  }
  if (loginid === null || loginid === "" || loginid === undefined) {
    loginid = await localStorage.getItem("loginUserID");
  }
  if (
    UserCompanyId === null ||
    UserCompanyId === "" ||
    UserCompanyId === undefined
  ) {
    UserCompanyId = await localStorage.getItem("UserCompanyId");
  }
  return fetch(
    Config.apiUrl +
      "QRCodeScanHistory/ArticleTimeWiseScanningAnalyticReport?StartDate=" +
      startdate +
      "&EndDate=" +
      enddate +
      "&PageCount=" +
      pagecount +
      "&ArticleId=" +
      articleId +
      "&ArticleVariantId=" +
      articlevariantId,
    {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        userCompanyID: loginid,
        Authorization: "Bearer " + Auth0token,
      },
    }
  )
    .then(handleResponse)
    .catch(handleError);
}

export async function getProductTimeWiseScanningAnalyticReport(
  startdate,
  enddate,
  articleId,
  articlevariantId,
  pagecount
) {
  if (Auth0token === null || Auth0token === "" || Auth0token === undefined) {
    Auth0token = await localStorage.getItem("Auth0token");
  }
  if (loginid === null || loginid === "" || loginid === undefined) {
    loginid = await localStorage.getItem("loginUserID");
  }
  if (
    UserCompanyId === null ||
    UserCompanyId === "" ||
    UserCompanyId === undefined
  ) {
    UserCompanyId = await localStorage.getItem("UserCompanyId");
  }
  return fetch(
    Config.apiUrl +
      "QRCodeScanHistory/ProductTimeWiseScanningAnalyticReport?StartDate=" +
      startdate +
      "&EndDate=" +
      enddate +
      "&PageCount=" +
      pagecount +
      "&ProductId=" +
      articleId +
      "&ProductVariantId=" +
      articlevariantId,
    {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        userCompanyID: loginid,
        Authorization: "Bearer " + Auth0token,
      },
    }
  )
    .then(handleResponse)
    .catch(handleError);
}

export async function getpersonalTimeWiseScanningAnalyticReport(
  startdate,
  enddate,
  pagecount,
  personalId
) {
  if (Auth0token === null || Auth0token === "" || Auth0token === undefined) {
    Auth0token = await localStorage.getItem("Auth0token");
  }
  if (loginid === null || loginid === "" || loginid === undefined) {
    loginid = await localStorage.getItem("loginUserID");
  }
  if (
    UserCompanyId === null ||
    UserCompanyId === "" ||
    UserCompanyId === undefined
  ) {
    UserCompanyId = await localStorage.getItem("UserCompanyId");
  }
  return fetch(
    Config.apiUrl +
      "QRCodeScanHistory/PersonalTimeWiseScanningAnalyticReport?StartDate=" +
      startdate +
      "&EndDate=" +
      enddate +
      "&PageCount=" +
      pagecount +
      "&PersonalQrCodeId=" +
      personalId,
    {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        userCompanyID: loginid,
        Authorization: "Bearer " + Auth0token,
      },
    }
  )
    .then(handleResponse)
    .catch(handleError);
}
